export default "__VITE_ASSET__f8b4ed24__"